/*
 * @Author: cc
 * @Date: 2020-01-12 16:20:11
 * @LastEditTime: 2020-05-06 17:56:16
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\resourceCenter\newspaperRemark\detail\newspaperRemarkDetail.js
 * @Description: 读报评报细览页面（借用资源中心数字报版面图逻辑）
 */
'use strict';

angular.module('newspaperRemarkDetailModule', []).controller('NewspaperRemarkDetailCtrl', [
    '$scope',
    '$state',
    '$q',
    '$filter',
    '$modal',
    'trsHttpService',
    'ueditorService',
    'loginService',
    'globleParamsSet',
    'modalDialog',
    'resCtrModalService',
    '$timeout',
    function($scope, $state, $q, $filter, $modal, trsHttpService, ueditorService, loginService, globleParamsSet, modalDialog, resCtrModalService, $timeout) {
        initStatus();
        initData();

        /**
         * [initStatus description]初始化状态函数开始
         * @return {[type]} [description] null
         */
        function initStatus() {
            $scope.page = {
                CURRPAGE: '1',
                PAGESIZE: 12,
                ITEMCOUNT: 0,
                PAGECOUNT: 1,
            };
            $scope.params = {
                bc: $state.params.bc,
                docpubtime: unescape($state.params.docpubtime),
                typeid: 'zyzx',
                modelid: 'getBmDetail',
                serviceid: 'epaper', // $stateParams.serviceid
                // sid: '0',
                pageSize: 50,
                pageNum: 1,
            };
            $scope.status = {
                userInfo: {}, // 当前登录用户信息（主要是很多请求需要用户ID）
                token: {}, // 有些接口需要token
                isShowDetail: false,
                docPubtime: $filter('date')($scope.params.docpubtime, 'yyyyMMdd').toString(),
                docPubtimeCN: getDocPubTimeCn(),
                hasData: true,
                paperName: $state.params.papername,
                imgOverWidth: 1, //  图片宽、高度 缩放比例
                listOpen: 'processView', // 默认选中的属性信息
                preCtrl: 'enabled',
                nextCtrl: 'enabled',
                isShowBmComment: false,
                isChangeTime: true,
                isInitCanvas: false,
                banMianRemarkCanInput: false,
                articleRemarkCanInput: false,
                banmianFlag: false,
                articleFlag: false,
                banmianScoreInt: true,
            };
            $scope.data = {
                items: [],
                space: '',
                detail: '',
                currItem: '',
                currIndex: '',
                dropDown: {
                    banciList: [],
                    selectedBanmian: {},
                },
                // 版面评价的评论
                banMianComment: '',
                // 版面评价的暂存评论
                banMianCommentTmp: '',
                //  稿件等级
                gjdj: [
                    {
                        name: 'A',
                        value: '1',
                    },
                    {
                        name: 'B',
                        value: '2',
                    },
                    {
                        name: 'C',
                        value: '3',
                    },
                    {
                        name: 'D',
                        value: '4',
                    },
                    {
                        name: 'E',
                        value: '5',
                    },
                ],
                gjTypes: {
                    '1': 'A',
                    '2': 'B',
                    '3': 'C',
                    '4': 'D',
                    '5': 'E',
                },
                gjdjType: {},
                customConfig: {
                    singleDatePicker: true, // 是否是单选框
                    maxDate: globleParamsSet.dateFormat(new Date(), '-'),
                },
            };
            // 监听日期变化
            listenDate();
            // 查询当前报纸是否有上一期和下一期
            findOtherTermsPubtime();
        }

        /**
         * [initStatus description]初始化请求数据函数开始
         * @return {[type]} [description] null
         */
        function initData() {
            getCurUserInfo().then((data) => {
                getToken();
                requestBanciDropDown(unescape($state.params.docpubtime)).then(function(data) {
                    $scope.params.bc = data.datas[0].bc;
                    $scope.params.pubTime = data.datas[0].ir_urltime;
                    $scope.params.siteName = data.datas[0].ir_sitename;
                    $scope.data.imgUrl = data.datas[0].ir_jppath;
                    $scope.data.banmianName = data.datas[0].bm;
                    requestData();
                });
            });
        }

        /**
         * [showVersionTime description]点击评论详情 弹出一个框
         * @return {[type]}      [description]
         */
        $scope.showRemarkDetail = function() {
            $modal.open({
                templateUrl: './resourceCenter/newspaperRemark/remarkInfo/remarkInfo.html',
                windowClass: 'editCompiledobjTime',
                backdrop: false,
                resolve: {
                    getRemarkDetail: function() {
                        return $scope.data.detail;
                    },
                },
                controller: 'newsPaperInfoCtrl',
            });
        };

        /**
         * [toCanBanMianInput description]进入可编辑状态 和取消状态
         *
         * @param   {[type]}  bool  [bool description]进入编辑状态
         *
         * @return  {[type]}        [return description]
         */
        $scope.toCanBanMianInput = function (bool) {
            $scope.status.banMianRemarkCanInput = !$scope.status.banMianRemarkCanInput;
            if (bool) {
                // 自动获取焦点
                $timeout(function () {
                    $scope.data.banMianCommentTmp = $scope.data.dropDown.selectedBanmian.evaluation;
                    var focusInput = document.getElementById('banMianRemarkInput');
                    focusInput.focus();
                    // focusInput.select();
                }, 100);
            } else {
                $scope.data.dropDown.selectedBanmian.evaluation = $scope.data.banMianCommentTmp;
            }
        };

        /**
         * [cancelremark description]文章评价
         *
         * @param   {[type]}  bool  [bool description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.cancelremark = function (bool) {
            $scope.status.articleRemarkCanInput = !$scope.status.articleRemarkCanInput;
            if (bool) {
                $scope.data.commentTpl = $scope.data.comment;
                // 自动获取焦点
                $timeout(function() {
                    var focusInput = document.getElementById('articeRemarkInput');
                    focusInput.focus();
                    // focusInput.select();
                }, 100);
            } else {
                $scope.data.comment = $scope.data.commentTpl;
            }
        };

        /**
         * [banmianFlag description]版面评价的一个失焦开关 点击到相应div里为true
         *
         * @return  {[type]}  [return description]
         */
        $scope.banmianFlag = function () {
            $scope.status.banmianFlag = false;
        };

        /**
         * [banmianFlag description]评价的一个失焦开关
         *
         * @return  {[type]}  [return description]
         */
        $scope.articleFlag = function () {
            $scope.status.articleFlag = false;
        };


        /**
         * [e description]
         *
         * @param   {[type]}  document  [document description]
         * @param   {[type]}  click     [click description]
         * @param   {[type]}  function  [function description]
         * @param   {[type]}  e         [e description]
         *
         * @return  {[type]}            [return description]
         */
        $(document).on('click', function (e) {
            $timeout(function() {
                if ($scope.status.articleFlag) {
                    $scope.status.articleRemarkCanInput = false;
                }
                if ($scope.status.banmianFlag) {
                    $scope.status.banMianRemarkCanInput = false;
                }
                $scope.status.articleFlag = true;
                $scope.status.banmianFlag = true;
            });
        });

        /**
         * [checkInt description]1-100之间正整数校验
         *
         * @param   {[type]}  data  [data description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.checkInt = function (data) {
            var regex = /^\d+$/;
            if (regex.test(data)){
                if (data > 100 || data < 0){
                    $scope.data.dropDown.selectedBanmian.scoreShowTips = true;
                    return;
                } else {
                    $scope.data.dropDown.selectedBanmian.scoreShowTips = false;
                }
            } else {
                $scope.data.dropDown.selectedBanmian.scoreShowTips = true;
                return;
            }
            saveLayoutReview();
        };

        /**
         * [confirmBanMianRemark description]保存操作
         *
         * @return  {[type]}  [return description]
         */
        $scope.confirmBanMianRemark = function () {
            // $scope.data.dropDown.selectedBanmian.evaluation = $scope.data.banMianCommentTmp;
            saveLayoutReview().then(
                function () {
                    $scope.status.banMianRemarkCanInput = !$scope.status.banMianRemarkCanInput;
                }
            );
        };

        /**
         * [saveLayoutREview description]保存版面评价的请求
         *
         * @return  {[type]}  [return description]
         */
        function saveLayoutReview(){
            var defer = $q.defer();
            var params = {
                bc: $scope.data.dropDown.selectedBanmian.bc,
                siteName: $scope.data.dropDown.selectedBanmian.ir_sitename,
                pubTime: $scope.data.dropDown.selectedBanmian.ir_urltime,
                evaluation: $scope.data.dropDown.selectedBanmian.evaluation,
                score: $scope.data.dropDown.selectedBanmian.score,
                username: $scope.status.userInfo.TRUENAME,
            };
            $scope.loadingPromise = trsHttpService
                .httpServer('/paperreview/paperReview/saveOrUpdateLayoutReviewForPC', params, 'post')
                .then((data) => {
                    if (data.code === '200') {
                        // modalDialog.alertType('版面评价', '保存成功', 'info');
                        defer.resolve();
                    } else {
                        modalDialog.alertType('版面评价', '保存失败', 'info');
                        defer.reject();
                    }
                });
            return defer.promise;
        }

        /**
         * [getCurUserInfo description] 获取当前用户信息
         * @return  {[type]}  [return description]
         */
        function getCurUserInfo() {
            var defer = $q.defer();
            loginService.getCurrLoginUser().then((data) => {
                $scope.status.userInfo = data;
                $scope.params.user_id = data.ID;
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [getToken description] 获取token
         * @return  {[type]}  [return description]
         */
        function getToken() {
            globleParamsSet.getTokenService($scope.status.userInfo.TENANTID).then((data) => {
                $scope.status.token = data;
            });
        }

        /**
         * [packageParams description]
         * @param   {[obj]}  banmian  [banmian description] 组装参数
         * @return  {[type]}          [return description]
         */
        function packageParams(banmian) {
            $scope.params.bc = banmian.bc;
            $scope.params.pubTime = banmian.ir_urltime;
            $scope.params.siteName = banmian.ir_sitename;
            $scope.data.imgUrl = banmian.ir_jppath;
            $scope.data.banmianName = banmian.bm;
        }

        /**
         * [requestBanciDropDown description]请求版次下拉框
         * @param   {[string]}  date  [date description] 时间字符串
         * @return  {[type]}          [return description]
         */
        function requestBanciDropDown(date) {
            var defer = $q.defer();
            var params = {
                docpubtime: date,
                siteName: $scope.status.paperName,
                user_id: $scope.status.userInfo.ID,
            };
            $scope.loadingPromise = trsHttpService.httpServer('/paperreview/paperReview/getPaperLayoutMenu', params, 'post').then(function(data) {
                var index = 0;
                //  版面目录下面取得name字段，要什么就拼什么
                angular.forEach(data.datas, function(value, key) {
                    //  要版次加名字
                    value.name = value.bc + '： ' + value.bm;
                    //  只要版次
                    value.value = value.bc;
                    if (value.bc === $scope.params.bc) {
                        index = key;
                    }
                });
                $scope.data.dropDown.banciList = data.datas;
                $scope.data.dropDown.selectedBanmian = $scope.data.dropDown.banciList[index];
                defer.resolve(data);
            },
            function(){
                $scope.status.hasData = false;
                $scope.data.banmianName = '所选日期没有报纸';
                return;
            });
            return defer.promise;
        }

        /**
         * [requestData description]请求数据函数开始
         * @return {[type]} [description] null
         */
        function requestData() {
            $scope.params.docpubtime = null;
            var canvas = document.getElementById('Img_a_canvas');
            var context = canvas.getContext('2d');
            context.clearRect(0, 0, canvas.width, canvas.height);
            $scope.data.gjdjType = {};
            $scope.data.comment = ''; // 切换时候清空稿件等级和评报记录
            $scope.data.commentTpl = '';
            $scope.data.items = [];
            $scope.loadingPromise = trsHttpService.httpServer('/paperreview/paperReview/getPaperDetails', $scope.params, 'post').then(function (data) {
                $scope.data.items = data.datas;
                $scope.data.banmianName = data.datas[0].bm;
                $scope.status.isShowDetail = false;
                $scope.data.detail = '';
                $scope.data.currItem = '';
                $scope.data.currIndex = '';
                var realWidth = data.datas[0] ? data.datas[0].ir_width : 0;
                var realHeight = data.datas[0] ? data.datas[0].ir_height : 0;
                var isFromXML = data.datas[0] && data.datas[0].remarks && data.datas[0].remarks === 'xml';
                var aspectRatio = realWidth / realHeight;
                var height = 680 / aspectRatio;
                data.datas.forEach((item, index) => {
                    const readList = item.zb.split(','); // 点位是以逆时针为顺序绘制的，第一个点事左下角的点
                    if (readList.length === 4) {
                        const setList = [readList[0], readList[1], readList[2], readList[1], readList[2], readList[3], readList[0], readList[3]];
                        data.datas[index].zb = setList.join(',');
                    }
                    data.datas[index].zb = CoordMax(item.zb, 680, height, realWidth, realHeight, isFromXML);
                    if (data.datas[index].bmzb){
                        data.datas[index].bmzb = CoordMax(item.bmzb, 680, height, realWidth, realHeight, isFromXML);
                    }
                });
                // 初始化canvas
                initCanvas();
                $('<img/>')
                    .attr('src', $scope.data.imgUrl)
                    .load(function() {
                        $('.left_Img').css({ width: 680 });
                        // $('#Img_a_image').css({ width: 680, height: height });
                        $('#Img_a_canvas').css({ width: 680, height: height });
                        $('#Img_a').css({ width: 680, height: height });
                        $('#Img_a_canvas').attr({ width: 680, height: height });
                        init_area(realWidth, realHeight, isFromXML);
                    });
            });
        }

        /**
         * [getDocPubTimeCn description] 获取中文日期
         * @return {[type]} [description]
         */
        function getDocPubTimeCn() {
            var dateCn = '';
            var day;
            var date = new Date(Date.parse(unescape($state.params.docpubtime)));
            dateCn += $filter('date')(date, 'yyyy年MM月dd日 ');
            day = date.getDay();
            switch (day) {
                case 1:
                    day = '星期一';
                    break;
                case 2:
                    day = '星期二';
                    break;
                case 3:
                    day = '星期三';
                    break;
                case 4:
                    day = '星期四';
                    break;
                case 5:
                    day = '星期五';
                    break;
                case 6:
                    day = '星期六';
                    break;
                case 0:
                    day = '星期日';
                    break;
            }
            return dateCn + day;
        }

        //  勾选原创稿二级单选的原创类型
        $scope.checkgjdj = function(item) {
            $scope.data.gjdjType.value == item.value ? ($scope.data.gjdjType = {}) : ($scope.data.gjdjType = item);
            // 如果单击了选项就要发请求
            // if ($scope.data.gjdjType == item) {
            $scope.remark();
            // }
        };

        /**
         * [searchWithKeyword description]选择版面
         * @param   {[type]}  banmian  [banmian description]
         * @return  {[type]}           [return description]
         */
        $scope.searchWithKeyword = function(banmian) {
            if ($scope.params.bc === banmian.BC) {
                return;
            }
            $scope.status.isChangeTime = false;
            packageParams(banmian);
            requestData();
        };

        /**
         * [searchWidthList description]点版面列表搜索
         *
         * @param   {[type]}  banmian  [banmian description]
         *
         * @return  {[type]}           [return description]
         */
        $scope.searchWidthList = function(banmian) {
            if ($scope.params.bc === banmian.BC) {
                return;
            }
            $scope.status.isChangeTime = false;
            packageParams(banmian);
            $scope.data.dropDown.selectedBanmian = banmian;
            $scope.data.imgUrl = banmian.ir_jppath;
            $scope.data.banmianname = banmian.bm;
            requestData();
        };

        /**
         * [returnToList description] 回到初始列表
         * @return  {[type]}  [return description]
         */
        $scope.returnToList = function() {
            if (!$scope.status.isShowDetail) {
                return;
            }
            $scope.status.isShowDetail = false;
            $scope.data.detail = '';
        };

        /**
         * [listenDate description]监听时间变化请求不同日期的报纸
         *
         * @return  {[type]}  [return description]
         */
        function listenDate() {
            $scope.$watch('status.docPubtime', function(newValue, oldValue, scope) {
                if (newValue && newValue !== oldValue) {
                    $scope.status.isChangeTime = true;
                    var newDate = $filter('date')(newValue._d || newValue, 'yyyy/MM/dd').toString();
                    if (newDate.indexOf('00:00:00') < 0) {
                        newDate += ' 00:00:00';
                    }
                    $scope.params.docpubtime = newDate;
                    // 此处改变url的时间
                    $state.params.docpubtime = newDate;
                    $state.transitionTo('newspaperRemarkDetail', $state.params, {
                        reload: false
                    });
                    requestBanciDropDown(newDate).then(function(data) {
                        findOtherTermsPubtime();
                        if (data.datas[0].length < 1) {
                            $scope.status.hasData = false;
                            $scope.data.banmianName = '所选日期没有报纸';
                            return;
                        } else {
                            $scope.status.hasData = true;
                        }
                        $scope.data.imgUrl = data.datas[0].ir_jppath;
                        $scope.data.banmianName = data.datas[0].bm;
                        $scope.params.bc = data.datas[0].bc;
                        // $scope.params.sid = data.datas[0].ir_sid;
                        $scope.params.pubTime = data.datas[0].ir_urltime;
                        $scope.params.siteName = data.datas[0].ir_sitename;
                        requestData();
                    });
                }
            });
        }

        //  **********************************canvas开始**************************************/
        var canvascheck = document.createElement('canvas');
        // var isIE = window.navigator.systemLanguage ? 1 : 0;
        var isVM = document.namespaces ? 1 : 0;
        var isJG = 0;
        var isCV = canvascheck.getContext ? 1 : 0;
        var jg = [];

        if (isVM) {
            if (document.namespaces['v'] == null) {
                document.namespaces.add('v', 'urn:schemas-microsoft-com:vml');
            }
        }

        /**
         * [fadeCanvas description] 渐进动画
         * @param   {[type]}  id    [id description]
         * @param   {[type]}  opac  [opac description]
         * @return  {[type]}        [return description]
         */
        function fadeCanvas(id, opac) {
            var obj = document.getElementById(id);
            if (opac <= 100) {
                obj.style.opacity = opac / 100;
                opac += 10;
                window.setTimeout(fadeCanvas(id, opac), 10);
            }
        }

        /**
         * [CoordMax description]处理传入点数据计算比例
         *
         * @param   {[type]}  coord  [coord description]传入的点位信息
         * @param   {[type]}  w      [w description]采集时候的宽度
         * @param   {[type]}  h      [h description]采集时候的高度
         * @param   {[type]}  realW  [realW description]实际页面显示宽度
         * @param   {[type]}  realH  [realH description]实际页面显示高度
         * @param   {[type]}  isFromXML  [isFromXML description]实际页面显示高度
         *
         * @return  {[type]}         [return description]
         */
        function CoordMax(coord, w, h, realW, realH, isFromXML) {
            var arrays = coord.split(',');
            var cd;
            var newCoord = arrays
                .map(function(v, k) {
                    if (!isFromXML) {
                        if (k % 2 == 0) {
                            cd = (v / realW) * w;
                        } else {
                            cd = (v / realH) * h;
                        }
                    } else {
                        if (k % 2 == 0) {
                            cd = v / 100 * w;
                        } else {
                            cd = v / 100 * h;
                        }
                    }
                    return parseInt(cd);
                }, this)
                .toString();
            return newCoord;
        }

        /**
         * [setAreaOver description]鼠标移动进来的时候进行动画的绘制
         *
         * @param   {[type]}  obj  [obj description]传入hover对象
         * @param   {[type]}  id   [id description]绘制canvas的id值（固定为：Img_a_canvas）
         * @param   {[type]}  b    [b description]填充背景颜色
         * @param   {[type]}  c    [c description]填充边框颜色
         * @param   {[type]}  o    [o description]背景透明度
         * @param   {[type]}  n    [n description]判断是否描边0不描  1描
         * @param   {[type]}  f    [f description]判断显示渐变动画
         * @param   {[type]}  z    [z description]控制jg不知道有啥用
         *
         * @return  {[type]}       [return description]
         */
        function setAreaOver(obj, id, b, c, o, n, f, z) {
            var i,
                j,
                x,
                y,
                context,
                p = '',
                canvas = document.getElementById(id);
            var v = obj.coords.split(',');
            if (isVM) {
                if (obj.shape.toLowerCase() == 'rect') {
                    canvas.innerHTML =
                        '<v:rect strokeweight="1" filled="t" stroked="' +
                        (n < 1 ? 't' : 'f') +
                        '" strokecolor="#' +
                        b +
                        '" style="zoom:1;margin:0;padding:0;display:block;position:absolute;left:' +
                        parseInt(v[0]) +
                        'px;top:' +
                        parseInt(v[1]) +
                        'px;width:' +
                        parseInt(v[2] - v[0]) +
                        'px;height:' +
                        parseInt(v[3] - v[1]) +
                        'px;"><v:fill color="#' +
                        c +
                        '" opacity="' +
                        o +
                        '" /></v:rect>';
                } else if (obj.shape.toLowerCase() == 'circle') {
                    canvas.innerHTML =
                        '<v:oval strokeweight="1" filled="t" stroked="' +
                        (n < 1 ? 't' : 'f') +
                        '" strokecolor="#' +
                        b +
                        '" style="zoom:1;margin:0;padding:0;display:block;position:absolute;left:' +
                        parseInt(v[0] - v[2]) +
                        'px;top:' +
                        parseInt(v[1] - v[2]) +
                        'px;width:' +
                        parseInt(v[2]) * 2 +
                        'px;height:' +
                        parseInt(v[2]) * 2 +
                        'px;"><v:fill color="#' +
                        c +
                        '" opacity="' +
                        o +
                        '" /></v:oval>';
                } else {
                    for (j = 2; j < v.length; j += 2) {
                        p += parseInt(v[j]) + ',' + parseInt(v[j + 1]) + ',';
                    }
                    canvas.innerHTML =
                        '<v:shape strokeweight="1" filled="t" stroked="' +
                        (n < 1 ? 't' : 'f') +
                        '" strokecolor="#' +
                        b +
                        '" coordorigin="0,0" coordsize="' +
                        canvas.width +
                        ',' +
                        canvas.height +
                        '" path="m ' +
                        parseInt(v[0]) +
                        ',' +
                        parseInt(v[1]) +
                        ' l ' +
                        p +
                        ' x e" style="zoom:1;margin:0;padding:0;display:block;position:absolute;top:0px;left:0px;width:' +
                        canvas.width +
                        'px;height:' +
                        canvas.height +
                        'px;"><v:fill color="#' +
                        c +
                        '" opacity="' +
                        o +
                        '" /></v:shape>';
                }
            } else if (isCV) {
                if (f < 1) {
                    canvas.style.opacity = 0;
                }
                context = canvas.getContext('2d');
                context.beginPath();
                context.lineWidth = '1';
                if (obj.shape.toLowerCase() == 'rect') {
                    context.rect(0.5 + parseInt(v[0]), 0.5 + parseInt(v[1]), parseInt(v[2] - v[0]), parseInt(v[3] - v[1]));
                    context.closePath();
                } else if (obj.shape.toLowerCase() == 'circle') {
                    context.arc(0.5 + parseInt(v[0]), 0.5 + parseInt(v[1]), parseInt(v[2]), 0, (Math.PI / 180) * 360, false);
                } else {
                    context.moveTo(parseInt(v[0]), parseInt(v[1]));
                    for (j = 2; j < v.length; j += 2) {
                        context.lineTo(parseInt(v[j]), parseInt(v[j + 1]));
                    }
                    context.closePath();
                }
                context.fillStyle = 'rgba(' + c + ',' + o + ')';
                context.strokeStyle = 'rgba(' + b + ',0)'; // 边框线暂时为透明
                context.fill();
                if (n < 1) {
                    context.stroke();
                }
                if (f < 1) {
                    fadeCanvas(id, 0);
                }
            } else {
                jg[z].setColor('#' + c);
                if (obj.shape.toLowerCase() == 'rect') {
                    jg[z].fillRect(parseInt(v[0]), parseInt(v[1]), parseInt(v[2] - v[0]) + 1, parseInt(v[3] - v[1]) + 1);
                } else if (obj.shape.toLowerCase() == 'circle') {
                    jg[z].fillEllipse(parseInt(v[0] - v[2]), parseInt(v[1] - v[2]), parseInt(v[2]) * 2 + 1, parseInt(v[2]) * 2 + 1);
                } else {
                    x = new Array();
                    y = new Array();
                    i = 0;
                    for (j = 0; j < v.length; j += 2) {
                        x[i] = parseInt(v[j]);
                        y[i] = parseInt(v[j + 1]);
                        i++;
                    }
                    jg[z].fillPolygon(x, y);
                }
                jg[z].paint();
            }
        }

        /**
         * [setAreaOut description]鼠标退出
         * @param   {[type]}  obj  [obj description]移除对象
         * @param   {[type]}  id   [id description]canvas的id
         * @param   {[type]}  f    [f description]判断是否渐变（但是没用。。）
         * @param   {[type]}  z    [z description]判断jq不知道干啥
         * @return  {[type]}       [return description]
         */
        function setAreaOut(obj, id, f, z) {
            var canvas = document.getElementById(id);
            if (isVM) {
                canvas.innerHTML = '';
            } else if (isJG) {
                jg[z].clear();
            } else if (isCV) {
                var context = canvas.getContext('2d');
                context.clearRect(0, 0, canvas.width, canvas.height);
            }
            for (var i = 0; i < $scope.data.items.length; i++) {
                if ($scope.data.items[i].mark) {
                    drawRemark($scope.data.items[i]);
                }
            }
        }

        /**
         * [findMax description]找寻页面的最大x、y（暂时）
         *
         * @param   {[type]}  coord  [coord description]
         *
         * @return  {[type]}         [return description]
         */
        function findMax(coord) {
            var arrays = coord.split(',');
            var cdw = 0;
            var cdh = 0;
            arrays.forEach(function(v, k) {
                if (k % 2 == 0) {
                    if (v >= cdw) {
                        cdw = v;
                    }
                } else {
                    if (v >= cdh) {
                        cdh = v;
                    }
                }
            });
            return [Number(cdw), Number(cdh)];
        }

        /**
         * [init_area description]进行数据初始化处理
         *
         * @param   {[type]}  realWidth   [realWidth description]
         * @param   {[type]}  realHeight  [realHeight description]
         *
         * @return  {[type]}              [return description]
         */
        function init_area(realWidth, realHeight) {
            var canvans_width = $('#Img_a_canvas').attr('width');
            var canvans_height = $('#Img_a_canvas').attr('height');
            if (!realWidth || !realHeight || realWidth === '0' || realHeight === '0') {
                // $('.forArchives')
                //     .find('area')
                //     .each(function() {
                //         var setList = findMax($(this).attr('coords'));
                //         if (setList[0] > changeWidth) {
                //             realWidth = setList[0];
                //         }
                //         if (setList[1] > changeHeight) {
                //             realHeight = setList[1];
                //         }
                //     });
            } else {
                realWidth = realWidth - 20;
                realHeight = realHeight - 20;
            }
            $('.forArchives')
                .find('area')
                .each(function() {
                    var $this = $(this);
                    var index = $this.index();
                    // var excursionZb = CoordMax($(this).attr('coords'), canvans_width, canvans_height, realWidth, realHeight);
                    // $this.attr('coords', excursionZb); // 转变坐标为map区域 坐标
                    $scope.data.items[index].excursionZb = $(this).attr('coords').split(','); // 获取转换后的偏移量
                    if ($scope.data.items[index].grade) {
                        // 表示被评报过就绘制
                        $scope.data.items[index].mark = $scope.data.items[index].grade;
                        drawRemark($scope.data.items[index]);
                    }
                    var $x = -70;
                    var $y = -80;
                    $this
                        .mouseover(function(e) {
                            if ($('.mapDiv').length > 0) {
                                return;
                            }
                            //  var name = $(this).attr("alt") == "无标题" ? '' : $(this).attr("alt");
                            var name = $(this).attr('alt');
                            // var index_num = $(this).index();
                            var mapClass = name != '无标题' ? 'mapDiv' : 'mapDiv hide';
                            var dom = "<div class='" + mapClass + "'><span class='name'></span></div>";
                            $('.resouCen-digitalDetail').append(dom);
                            $('.name').text(name);
                            $('.mapDiv')
                                .css({
                                    top: e.pageY + $y + 'px',
                                    left: e.pageX + $x + 'px',
                                })
                                .show('fast');
                        })
                        .mouseout(function() {
                            $('.mapDiv').remove();
                        })
                        .mousemove(function(e) {
                            $('.mapDiv').css({
                                top: e.pageY + $y + 'px',
                                left: e.pageX + $x + 'px',
                            });
                        });
                });
        }

        /**
         * [drawRemark description] 绘制标语
         * @param   {[object]}  article  [coordinate description] 文章信息
         * @return  {[type]}             [return description]
         */
        function drawRemark(article) {
            var context = document.getElementById('Img_a_canvas').getContext('2d');
            var coordinate = article.excursionZb;
            context.lineWidth = 2.0;
            context.strokeStyle = '#d64541';
            context.beginPath();
            context.moveTo(coordinate[0] * 1, coordinate[1] * 1);
            context.lineTo(coordinate[2] * 1, coordinate[3] * 1);
            context.lineTo(coordinate[4] * 1, coordinate[5] * 1);
            context.lineTo(coordinate[6] * 1, coordinate[7] * 1);
            context.closePath();
            context.stroke();
            context.font = '30px bold 黑体';
            // 设置颜色
            context.fillStyle = '#d64541';
            // 设置水平对齐方式
            context.textAlign = 'center';
            // 设置垂直对齐方式
            context.textBaseline = 'middle';
            var offset = (coordinate[2] - coordinate[0]) / 2;
            // 绘制文字（参数：要写的字，x坐标，y坐标）
            var x = coordinate[0] * 1 + offset;
            // var x = coordinate[6] * 1 + 20;
            var y = coordinate[7] * 1 - 20;
            context.fillText($scope.data.gjTypes[article.mark], x, y);
        }

        /**
         * [initCanvas description]初始化canvas
         *
         * @return  {[type]}  [return description]
         */
        function initCanvas() {
            if ($scope.status.isInitCanvas) {
                return;
            }
            $('.forArchives').delegate('.newsPaper', 'mouseover mouseout', function(event) {
                if (event.type == 'mouseover') {
                    setAreaOver(this, 'Img_a_canvas', '39,84,128', '254,255,96', '0.4', 0, 0, 0);
                } else if (event.type == 'mouseout') {
                    setAreaOut(this, 'Img_a_canvas', 0, 0);
                }
            });
            $scope.status.isInitCanvas = true;
        }
        //  **********************************canvas结束**************************************/

        /**
         * [getReviewAndGrade description]在点击稿件的时候获取评论和等级取最后一次评论并回显
         *
         * @param   {[type]}  params  [params description]
         * @return  {[type]}          [return description]
         */
        function getReviewAndGrade() {
            var params = {
                guid: $scope.data.detail.zb_guid,
            };
            trsHttpService.httpServer('/paperreview/paperReviewLog/findByGuid', params, 'post').then(function(data) {
                $scope.data.reviewAndGrade = data.datas;
                if ($scope.data.reviewAndGrade.length) {
                    $scope.data.comment = $scope.data.reviewAndGrade[0].review;
                    let grade = $scope.data.reviewAndGrade[0].grade;
                    $scope.data.gjdjType = {
                        name: String.fromCharCode(64 + parseInt(grade)),
                        value: grade,
                    };
                }
            });
        }

        /**
         * [checkDetail description]查看稿件详情
         *
         * @param   {[type]}  item   [item description]
         * @param   {[type]}  index  [index description]
         *
         * @return  {[type]}         [return description]
         */
        $scope.checkDetail = function(item, index) {
            if ($scope.data.currIndex === index) {
                return;
            }
            var len = $scope.data.items.length - 1;
            if (len === 0) {
                $scope.status.preCtrl = 'disabled';
                $scope.status.nextCtrl = 'disabled';
            } else if (len === 1) {
                if (index === 0) {
                    $scope.status.preCtrl = 'disabled';
                    $scope.status.nextCtrl = 'enabled';
                } else {
                    $scope.status.preCtrl = 'enabled';
                    $scope.status.nextCtrl = 'disabled';
                }
            } else {
                if (index === 0) {
                    $scope.status.preCtrl = 'disabled';
                    $scope.status.nextCtrl = 'enabled';
                } else if (index === len) {
                    $scope.status.preCtrl = 'enabled';
                    $scope.status.nextCtrl = 'disabled';
                } else {
                    $scope.status.preCtrl = 'enabled';
                    $scope.status.nextCtrl = 'enabled';
                }
            }
            for (let i = 0; i < $scope.data.items.length; i++) {
                if (i === index) {
                    $scope.data.items[index].isHover = 'hover';
                } else {
                    $scope.data.items[index].isHover = '';
                }
            }
            $scope.data.gjdjType = {};
            let params;
            let url;
            if (item.sid) {
                params = {
                    guid: item.sid
                };
                url = '/paperreview/paperReview/getDetailData';
            } else {
                params = {
                    siteName: $scope.status.paperName,
                    puburl: item.ir_urlname,
                    user_id: $scope.status.userInfo.ID,
                };
                url = '/paperreview/paperReview/getArticleDetail';
            }
            $scope.data.comment = ''; // 切换时候清空稿件等级和评报记录
            $scope.loadingPromise = trsHttpService.httpServer(url, params, 'post').then(function(data) {
                $scope.data.detail = data.datas[0];
                $scope.data.detail.content = dealContent($scope.data.detail.content);
                $scope.status.isShowDetail = true;
                $scope.data.currItem = data.datas[0];
                $scope.data.currIndex = index;
                getReviewAndGrade();
            });
        };

        /**
         * [jumpToDraft description]上一篇/下一篇
         *
         * @param   {[type]}  isNext  [isNext description]
         *
         * @return  {[type]}          [return description]
         */
        $scope.jumpToDraft = function(isNext) {
            if (
                (!isNext && $scope.data.currIndex === 0) ||
                (isNext && $scope.data.currIndex === $scope.data.items.length - 1) ||
                !$scope.status.isShowDetail
            ) {
                return;
            }

            var index = isNext ? $scope.data.currIndex + 1 : $scope.data.currIndex - 1;
            var item = $scope.data.items[index];

            $scope.checkDetail(item, index);
        };

        /**
         * [jumpToBanmian description]上一版/下一版
         * @param   {[type]}  isNext  [isNext description]
         * @return  {[type]}          [return description]
         */
        $scope.jumpToBanmian = function(isNext) {
            var originalIndex = $scope.data.dropDown.banciList.indexOf($scope.data.dropDown.selectedBanmian),
                index = isNext ? originalIndex + 1 : originalIndex - 1;
            if ((!isNext && originalIndex === 0) || (isNext && originalIndex === $scope.data.dropDown.banciList.length - 1)) {
                return;
            }
            $scope.data.dropDown.selectedBanmian = $scope.data.dropDown.banciList[index];
            $scope.params.bc = $scope.data.dropDown.banciList[index].bc;
            $scope.data.imgUrl = $scope.data.dropDown.banciList[index].ir_jppath;
            $scope.params.pubTime = $scope.data.dropDown.banciList[index].ir_urltime;
            $scope.params.siteName = $scope.data.dropDown.banciList[index].ir_sitename;
            // $scope.params.sid = $scope.data.dropDown.banciList[index].ir_sid;
            $scope.data.banmianName = $scope.data.dropDown.banciList[index].bm;
            requestData();
        };

        /**
         * [findOtherTermsPubtime description]
         * @return {[type]} [description]
         */
        function findOtherTermsPubtime() {
            var nowdate = $filter('date')(new Date(), 'yyyy/MM/dd').toString() + ' 00:00:00';
            var mydate = new Date(Date.parse(unescape($state.params.docpubtime)));
            // var mydate = new Date(Date.parse(unescape($scope.status.docPubtime)));
            $scope.status.hasNext = mydate.setDate(mydate.getDate() + 1);
            $scope.status.hasPrev = mydate.setDate(mydate.getDate() - 2);
            $scope.status.hasNext = $filter('date')($scope.status.hasNext, 'yyyy/MM/dd').toString() + ' 00:00:00';
            $scope.status.hasPrev = $filter('date')($scope.status.hasPrev, 'yyyy/MM/dd').toString() + ' 00:00:00' ;
            if ((new Date($scope.status.hasNext)).getTime() > (new Date(nowdate)).getTime()) {
                $scope.status.hasNext = false;
            }
        }
        
        /**
         * [jumpToPhase description] 上一期/下一期
         * @param  {Boolean} isNext [description]
         * @return {[type]}         [description]
         */
        $scope.jumpToPhase = function(isNext) {
            var params = $state.params;
            if ($scope.status.hasNext && isNext) {
                params.docpubtime = $scope.status.hasNext;
            } else if ($scope.status.hasPrev && !isNext) {
                params.docpubtime = $scope.status.hasPrev;
            } else {
                return;
            }
            // 此处用于 高亮定位的参数
            $state.transitionTo('newspaperRemarkDetail', $state.params, {
                reload: false
            });
            $state.reload($state.current);
            // $state.go($state.current.name, params, { reload: true });
        };

        /**
         * [dealContent description]处理详情内容的格式
         *
         * @param   {[type]}  content  [content description]
         *
         * @return  {[type]}           [return description]
         */
        function dealContent(content) {
            content = content.replace(/\r\n/g, '<br/>');
            content = content.replace(/\r/g, '<br/>');
            content = content.replace(/\n/g, '<br/>');
            // content = content.replace(/<img/g, '<img style="max-width:512px;"');
            return ueditorService
                .replaceHtmlBlank(content)
                .replace(/(<(?:p|div)[^>]*>(?:<(?:span|b)[^>]*>)*)(?:&nbsp;| |　)*/gi, '$1　　')
                .replace(/(<br[^>]*>)(?:&nbsp;| |　)*/gi, '$1　　')
                .replace(/>　　</g, '><')
                .replace(/style="[^>]*"/g, '');
        }

        /**
         * [titleMouseOver description] 新闻标题hover联动效果
         * @param   {[type]}  item   [item description]
         * @param   {[type]}  index  [index description]
         * @return  {[type]}         [return description]
         */
        $scope.titleMouseOver = function(item, index) {
            $scope.data.items[index].isHover = 'hover';
        };
        
        /**
         * [titleMouseOut description]
         * @param   {[type]}  item   [item description]
         * @param   {[type]}  index  [index description]
         * @return  {[type]}         [return description]
         */
        $scope.titleMouseOut = function(item, index) {
            $scope.data.items[index].isHover = '';
        };

        /**
         * [remark description]打标
         * @return  {[type]}  [return description]
         */
        $scope.remark = function () {
            // 可以传空值
            // if (!$scope.data.gjdjType.value) {
            //     // 没有选择等级点报存的时候给出提示
            //     modalDialog.alertType('请选择稿件等级', '', 'warning', false);
            //     return;
            // }
            var params = {
                grade: $scope.data.gjdjType.value,
                review: $scope.data.comment,
                username: $scope.status.userInfo.TRUENAME,
                dept: $scope.status.userInfo.DEPT,
                guid: $scope.data.detail.zb_guid,
                bc: $scope.data.items[$scope.data.currIndex].bc,
                urlname: $scope.data.items[$scope.data.currIndex].ir_urlname,
                sitename: $scope.data.items[$scope.data.currIndex].ir_sitename,
                sid: $scope.data.items[$scope.data.currIndex].sid,
                token: $scope.status.token.token,
            };
            $scope.loadingPromise = trsHttpService
                .httpServer('/paperreview/paperReview/saveOrUpdatePaperReviewForPC', params, 'post')
                .then((data) => {
                    // 这里要判断一下，如果选择稿件的等级为空，则不需要绘制等级
                    if (!!$scope.data.gjdjType.value) {
                        $scope.data.items[$scope.data.currIndex].mark = $scope.data.gjdjType.value;
                        setAreaOut('', 'Img_a_canvas', 0, 0);
                        drawRemark($scope.data.items[$scope.data.currIndex]);
                    } else {
                        $scope.data.items[$scope.data.currIndex].mark = '';
                        setAreaOut('', 'Img_a_canvas', 0, 0);
                    }
                    $scope.status.articleRemarkCanInput = false;
                });
        };

        $scope.publishBMComment = function() {
            $scope.isShowBmComment = false;
            let options = {
                data: $scope.data.dropDown.selectedBanmian.evaluation || '',
            };
            resCtrModalService.commentModal(options).then(function(comment) {
                if (comment.data !== '') {
                    var params = {
                        bc: $scope.data.dropDown.selectedBanmian.bc,
                        siteName: $scope.data.dropDown.selectedBanmian.ir_sitename,
                        pubTime: $scope.data.dropDown.selectedBanmian.ir_urltime,
                        evaluation: comment.data,
                    };
                    $scope.loadingPromise = trsHttpService
                        .httpServer('/paperreview/paperReview/saveOrUpdateLayoutReviewForPC', params, 'post')
                        .then((data) => {
                            if (data.code === '200') {
                                modalDialog.alertType('版面评价', '保存成功', 'info');
                                $scope.data.dropDown.selectedBanmian.evaluation = comment.data;
                            }
                        });
                }
            }, function(){
                modalDialog.alertType('版面评价', '保存失败', 'error');
            });
        };
    },
]).filter('getDetailInfos', function(){
    return function(data){
        let time = data.docpubtime;
        let date = transTimeToZh(time);
        let result = '全文共' + data.txs + '字，《' + data.zb_source_site + '》 （' + date + ' ' + data.bc + '-' + data.bm + '）';
        return result;
    };

    /**
     * [transTimeToZh 将日期转换为中文格式]
     *
     * @param   {[type]}  time  [time description]
     *
     * @return  {[type]}        [return description]
     */
    function transTimeToZh(time){
        if (!time) {
            return '';
        } else {
            return time.split(' ')[0].replace('-', '年').replace('-', '月') + '日';
        }
    }
}).filter('formatTextareaContent', function(){
    return function (txt) {
        if (!txt) {
            return;
        } else {
            return txt.split('\n').map(function(item){
                return '<p>' + item + '</p>';
            }).join('');
        }
        
    };
});
